import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, ViewEncapsulation, Input, NgModule } from '@angular/core';
import * as i3 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import * as i5 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i6 from '@angular/router';
import { RouterModule } from '@angular/router';
import * as i4 from '@xpo-ltl/ngx-ltl-core/button';
import { XpoButtonModule } from '@xpo-ltl/ngx-ltl-core/button';
import * as i2 from '@xpo-ltl/ngx-ltl-core/xpo-ltl-popover';
import { XpoLtlPopoverModule } from '@xpo-ltl/ngx-ltl-core/xpo-ltl-popover';

function XpoAccountPopover_a_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 16);
    i0.ɵɵelement(1, "img", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const _r2 = i0.ɵɵreference(3);
    i0.ɵɵproperty("xpoLtlpopoverTriggerFor", _r2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("src", ctx_r0.config.imageUri, i0.ɵɵsanitizeUrl);
} }
function XpoAccountPopover_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 18);
    i0.ɵɵlistener("click", function XpoAccountPopover_div_1_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r5 = i0.ɵɵnextContext(); return ctx_r5.togglePopover(); });
    i0.ɵɵelementStart(1, "mat-icon", 19);
    i0.ɵɵtext(2, "account_circle");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "mat-icon", 20);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const _r2 = i0.ɵɵreference(3);
    i0.ɵɵproperty("xpoLtlpopoverTriggerFor", _r2);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r1.popoverIcon);
} }
function XpoAccountPopover_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r3.nameInitials, " ");
} }
function XpoAccountPopover_li_16_a_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 25);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const link_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("href", link_r7.url, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(link_r7.title);
} }
const _c0 = function (a0) { return [a0]; };
function XpoAccountPopover_li_16_a_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 26);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const link_r7 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(2, _c0, link_r7.url));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(link_r7.title);
} }
function XpoAccountPopover_li_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 22);
    i0.ɵɵtemplate(1, XpoAccountPopover_li_16_a_1_Template, 2, 2, "a", 23);
    i0.ɵɵtemplate(2, XpoAccountPopover_li_16_a_2_Template, 2, 4, "a", 24);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const link_r7 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !link_r7.routerLink);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", link_r7.routerLink);
} }
class XpoAccountPopover {
    constructor() {
        this.nameInitials = '';
        this.isPopoverOpened = false;
        this.popoverIcon = 'arrow_drop_down';
    }
    ngOnInit() {
        // Get name initials
        let name = '';
        if (this.config.name) {
            const configName = this.config.name;
            if (configName.split(' ')[0]) {
                name = configName.split(' ')[0].charAt(0);
            }
            let lastName = '';
            if (configName.split(' ')[1]) {
                lastName = configName.split(' ')[1].charAt(0);
            }
            this.nameInitials = `${name}${lastName}`.toUpperCase();
        }
    }
    signOut() {
        if (this.config.onSignOutCallback) {
            this.config.onSignOutCallback();
        }
    }
    onPopoverClose() {
        this.togglePopover();
    }
    togglePopover() {
        this.isPopoverOpened = !this.isPopoverOpened;
        this.popoverIcon = this.isPopoverOpened ? 'arrow_drop_up' : 'arrow_drop_down';
    }
}
XpoAccountPopover.ɵfac = function XpoAccountPopover_Factory(t) { return new (t || XpoAccountPopover)(); };
XpoAccountPopover.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: XpoAccountPopover, selectors: [["xpo-account-popover"]], hostAttrs: [1, "xpo-AccountPopover"], inputs: { config: "config" }, decls: 20, vars: 6, consts: [["class", "xpo-AccountPopover-actionLink", 3, "xpoLtlpopoverTriggerFor", 4, "ngIf"], ["class", "xpo-AccountPopover-actionLink", 3, "xpoLtlpopoverTriggerFor", "click", 4, "ngIf"], ["position", "below", "color", "accent", "hideCloseButton", "true", "caretPosition", "end", 3, "closed"], ["popover", "xpoLtlPopover"], [1, "xpo-AccountPopover-content"], [1, "xpo-PopoverMenu-content"], ["class", "xpo-AccountPopover-welcome xpo-AccountPopover-welcome-initials", 4, "ngIf"], [1, "xpo-AccountPopover-welcome", "xpo-AccountPopover-welcome-name"], [1, "xpo-AccountPopover-welcome"], [1, "xpo-AccountPopover-welcome-email"], [1, "xpo-AccountPopover-divider"], [1, "xpo-PopoverMenu-item"], [1, "xpo-AccountPopover-linkList"], ["class", "xpo-AccountPopover-linkItem", 4, "ngFor", "ngForOf"], [1, "xpo-AccountPopover-footer"], ["mat-flat-button", "", "xpoSmallButton", "", 3, "click"], [1, "xpo-AccountPopover-actionLink", 3, "xpoLtlpopoverTriggerFor"], [1, "xpo-AccountPopover-img--sm", 3, "src"], [1, "xpo-AccountPopover-actionLink", 3, "xpoLtlpopoverTriggerFor", "click"], [1, "xpo-AccountPopover-actionLink-user"], [1, "xpo-AccountPopover-actionLink-arrow"], [1, "xpo-AccountPopover-welcome", "xpo-AccountPopover-welcome-initials"], [1, "xpo-AccountPopover-linkItem"], ["class", "xpo-AccountPopover-link", "target", "_blank", 3, "href", 4, "ngIf"], ["class", "xpo-AccountPopover-link", 3, "routerLink", 4, "ngIf"], ["target", "_blank", 1, "xpo-AccountPopover-link", 3, "href"], [1, "xpo-AccountPopover-link", 3, "routerLink"]], template: function XpoAccountPopover_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, XpoAccountPopover_a_0_Template, 2, 2, "a", 0);
        i0.ɵɵtemplate(1, XpoAccountPopover_div_1_Template, 5, 2, "div", 1);
        i0.ɵɵelementStart(2, "xpo-ltl-popover", 2, 3);
        i0.ɵɵlistener("closed", function XpoAccountPopover_Template_xpo_ltl_popover_closed_2_listener() { return ctx.onPopoverClose(); });
        i0.ɵɵelementStart(4, "xpo-ltl-popover-content", 4);
        i0.ɵɵelementStart(5, "div", 5);
        i0.ɵɵtemplate(6, XpoAccountPopover_div_6_Template, 3, 1, "div", 6);
        i0.ɵɵelementStart(7, "div", 7);
        i0.ɵɵelementStart(8, "span");
        i0.ɵɵtext(9);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "div", 8);
        i0.ɵɵelementStart(11, "span", 9);
        i0.ɵɵtext(12);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(13, "hr", 10);
        i0.ɵɵelementStart(14, "div", 11);
        i0.ɵɵelementStart(15, "ul", 12);
        i0.ɵɵtemplate(16, XpoAccountPopover_li_16_Template, 3, 2, "li", 13);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(17, "div", 14);
        i0.ɵɵelementStart(18, "button", 15);
        i0.ɵɵlistener("click", function XpoAccountPopover_Template_button_click_18_listener() { return ctx.signOut(); });
        i0.ɵɵtext(19, "SIGN OUT");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", ctx.config.imageUri);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.config.imageUri);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngIf", ctx.nameInitials);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.config.name);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.config.email);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngForOf", ctx.config.links);
    } }, directives: [i1.NgIf, i2.XpoLtlPopover, i2.XpoLtlPopoverContent, i1.NgForOf, i3.MatButton, i4.XpoSmallButton, i2.XpoLtlPopoverTrigger, i5.MatIcon, i6.RouterLinkWithHref], styles: [".flex--stretch{flex:1}.xpo-AccountPopover{cursor:pointer;display:inline-flex;overflow:hidden;padding-left:4px}.xpo-AccountPopover-content{width:220px}.xpo-AccountPopover-actionLink{align-items:center;color:#4a4a4a;display:inline-flex;height:30px;width:35px}.xpo-AccountPopover-actionLink .mat-icon{align-items:center;display:flex;width:24px}.xpo-AccountPopover-actionLink-user{font-size:1.428rem;height:auto;width:auto}.xpo-AccountPopover-actionLink-arrow{direction:rtl;font-size:30px;height:auto;width:24px}.xpo-AccountPopover-img--sm,.xpo-AccountPopover-img--lg{border-radius:50%;display:block}.xpo-AccountPopover-img--sm{height:20px;margin-top:6px;width:20px}.xpo-AccountPopover-img--lg{height:72px;width:72px}.xpo-AccountPopover-welcome{align-items:center;display:flex;justify-content:center;line-height:24px}.xpo-AccountPopover-welcome-email{color:#757575}.xpo-AccountPopover-welcome-img{margin-bottom:8px;margin-right:8px;margin-top:8px}.xpo-AccountPopover-welcome-salutation{display:block;font-size:1.143rem;margin-bottom:8px}.xpo-AccountPopover-welcome-name{padding-top:8px}.xpo-AccountPopover-welcome-name span{font-size:1.428rem;font-weight:500}.xpo-AccountPopover-welcome-initials span{align-items:center;border:2px solid #d32f2f;border-radius:50%;display:flex;font-family:\"Roboto\",\"Helvetica Neue\",Arial,sans-serif;font-size:1.143rem;font-weight:700;height:40px;justify-content:center;width:40px}.xpo-AccountPopover-linkList{list-style-type:none;margin:8px;padding:0}.xpo-AccountPopover-linkItem{margin-bottom:8px;text-align:center}.xpo-AccountPopover-linkItem:last-of-type{margin-bottom:0}.xpo-AccountPopover-link{font-size:1rem;line-height:24px;text-decoration:none}.xpo-AccountPopover-version{color:#6f6f6f;font-weight:300;padding-left:8px}.xpo-AccountPopover-divider{margin:8px 0 6px}.xpo-AccountPopover-footer{display:flex;flex-direction:row;flex-grow:1;justify-content:center}.xpo-PopoverMenu-item{display:flex;justify-content:center;margin:8px 16px 16px}\n"], encapsulation: 2, changeDetection: 0 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoAccountPopover, [{
        type: Component,
        args: [{
                selector: 'xpo-account-popover',
                templateUrl: './account-popover.component.html',
                styleUrls: ['./account-popover.component.scss'],
                host: {
                    class: 'xpo-AccountPopover',
                },
                changeDetection: ChangeDetectionStrategy.OnPush,
                encapsulation: ViewEncapsulation.None,
            }]
    }], null, { config: [{
            type: Input
        }] }); })();

class XpoAccountPopoverModule {
}
XpoAccountPopoverModule.ɵfac = function XpoAccountPopoverModule_Factory(t) { return new (t || XpoAccountPopoverModule)(); };
XpoAccountPopoverModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: XpoAccountPopoverModule });
XpoAccountPopoverModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [[CommonModule, XpoLtlPopoverModule, MatButtonModule, MatIconModule, XpoButtonModule, RouterModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(XpoAccountPopoverModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, XpoLtlPopoverModule, MatButtonModule, MatIconModule, XpoButtonModule, RouterModule],
                declarations: [XpoAccountPopover],
                exports: [XpoAccountPopover],
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(XpoAccountPopoverModule, { declarations: [XpoAccountPopover], imports: [CommonModule, XpoLtlPopoverModule, MatButtonModule, MatIconModule, XpoButtonModule, RouterModule], exports: [XpoAccountPopover] }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { XpoAccountPopover, XpoAccountPopoverModule };
